<template>
  <div class="flex w-full p-2 justify-center">
    <div class="w-1/2 flex flex-wrap justify-center" ref="requestWrapper">
      <h2 class="w-full text-center my-2">Request your alpha access !</h2>
      <div class="w-full my-2 flex justify-center">
        <input class="bg-opaque" :class="{'has-error': errorBag['email']}" type="text" placeholder="email" v-model="email">
      </div>
      <div class="w-full my-2 flex justify-center">
        <input class="bg-opaque" :class="{'has-error': errorBag['username']}" type="text" placeholder="desired username" v-model="username">
      </div>
      <div class="w-full flex justify-center">
        <textarea class="p-2 bg-opaque" v-model="message" cols="30" rows="5" placeholder="why are you interested on minderal? (optional)"></textarea>
      </div>
      <button class="button" @click="sendRequest">Request</button>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import * as emailjs from 'emailjs-com'
export default {
  name: 'home',
  data () {
    return {
      email: '',
      username: '',
      message: '',
      errorBag: []
    }
  },
  beforeMount () {
    emailjs.init('user_lDntRVlrxqhPoB5QnMf7X')
  },
  methods: {
    sendRequest () {
      this.errorBag = []
      if (this.validate(this.email, this.username)) {
        emailjs.send('minderal', 'template_yl5FX829', {
          'from_name': this.email,
          'username': this.username,
          'message_html': this.message
        })
        Swal.fire(
          'Message sent',
          'We will contact you as soon as posible',
          'success'
        )
        this.$router.push({ path: '/' })
      } else {
        this.shakeElement(this.$refs.requestWrapper)
      }
    },
    validate (email, username) {
      let isValid = true
      if (!this.validateEmail(email)) {
        this.errorBag['email'] = true
        isValid = false
      }
      if (username === '') {
        this.errorBag['username'] = true
        isValid = false
      }
      return isValid
    },
    validateEmail (email) {
      // eslint-disable-next-line no-useless-escape
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }

  }
}
</script>

<style lang="scss" scoped>
input {
  border: none;
  color: white;
  text-align: center;
  &::placeholder {
    color: rgba(255, 255, 255, 0.48);
  }
}
textarea {
  &::placeholder {
    color: rgba(255, 255, 255, 0.48);
  }
}
</style>
